import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Note from './Note';
const ErrorNote = ({ errorId, show = true, errorTexts }) => {
    return _jsx(_Fragment, { children: errorId && errorTexts[errorId] && _jsx(Note, { type: 'error', show: show, children: errorTexts[errorId] }) });
};
export default ErrorNote;
